import $ from 'jquery';
import EventTarget from '../../helper/EventTarget';
import scissorsIcon from './icon-scissors.svg';
import sortBy from 'lodash/sortBy';
const createjs = require('createjs');

const enableActiveEdges = false;

function hexToRgb(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    }
    : null;
}

export function CanvasService() {
  'ngInject';

  let stageConfig = { isDirty: false };
  let eventTarget = new EventTarget();

  let defaultBorderWidth = 5;
  let previewImageCounter = 4;

  // Convert padding from edge milimeter to actual pixels.
  // Average photo size is 15x10 cm
  let factor = 1200 / 100;
  let defaultMarginFromEdges = 3 * factor;
  let maxNegativeDragOffset = -10 * factor;
  let previewImages = [];

  for (let i = 1; i <= previewImageCounter; i++) {
    let path = '/assets/images/preview-images/preview-image-' + (4 + i) + '.jpg';
    let image = new Image();
    previewImages.push({ image, width: 0, height: 0 });
    image.onload = function () {
      let image = this;
      for (let y = 0; y < previewImages.length; y++) {
        if (previewImages[y].image.src == image.src) {
          previewImages[y].width = image.width;
          previewImages[y].height = image.height;
        }
      }
    };
    image.src = path;
  }

  return {
    stageInitialized(handler) {
      window.stageInitHandler = window.stageInitHandler || [];

      if (window.globalStageInstance) {
        handler();
        return;
      }

      window.stageInitHandler.push(handler);
    },
    setStageInitialized(stage) {
      window.globalStageInstance = stage;

      if (!window.stageInitHandler) return;

      for (let i = 0; i < window.stageInitHandler.length; i++) {
        let handler = window.stageInitHandler[i];
        handler(stage);
      }

      window.stageInitHandler = [];

      let reference = this;

      // Register stage handler
      stage.on('stagemouseup', function (evt) {
        reference.unsetItemSelection(true);
      });
    },
    getStage() {
      if (!window.globalStageInstance) return 'Stage not found.';

      return window.globalStageInstance;
    },
    setDirty() {
      stageConfig.isDirty = true;
    },
    getIsDirty() {
      return stageConfig.isDirty;
    },
    getStateDefaults() {
      return {
        isDirty: false,
        isOutputRenderMode: false,
        layoutName: 'n/a',
        previewImages: [],
        borderType: 'none',
        borderColor: '#ffffff',
        borderWidth: 0,
        borderRadius: 10,
        backgroundColor: '#ffffff',
        backgroundImage: null,
        backgroundImageScale: 'cover',
        backgroundImageRotation: 0,
        textBoxes: [],
        customImages: [],
        shapes: [],
        useDivider: false,
        useDividerHorizontal: false,
      };
    },
    setStageDefaults() {
      stageConfig = this.getStateDefaults();
    },
    events: eventTarget,
    // Helper functions
    getBounds() {
      let stage = this.getStage();
      let canvas = stage.canvas;

      return { width: canvas.width, height: canvas.height };
    },
    setBounds(width, height, complete) {
      let maxW = 700,
        maxH = 700,
        scaleW = 1,
        scaleH = 1,
        scalingFactor = 1;

      this.clearStage();
      let stage = this.getStage();
      stage.update();
      let canvas = stage.canvas;

      if (width > maxW) scaleW = maxW / width;

      if (height > maxH) scaleH = maxH / height;

      scalingFactor = scaleW < scaleH ? scaleW : scaleH;

      // The 'style' width & height the user sees
      let visibleWidth = width * scalingFactor;
      let visibleHeight = height * scalingFactor;

      //console.log({ width: width, height: height, visibleWidth: visibleWidth, visibleHeight: visibleHeight });

      if (canvas.width == width && canvas.height == height) {
        if (complete) complete();
      } else {
        $(canvas).animate({ width: visibleWidth, height: visibleHeight }, 600, 'swing', function () {
          canvas.width = width;
          canvas.height = height;
          stage.update();
          if (complete) complete();
        });
      }
    },
    addElement(element, zindex) {
      let stage = this.getStage();
      stage.addChild(element);
      //stage.addChildAt(element, zindex);
    },
    clearStage() {
      let stage = this.getStage();
      stage.removeAllChildren();
    },
    isEmpty() {
      const defaultConfig = this.getStateDefaults();
      const currentConfig = JSON.parse(JSON.stringify(this.getStageConfig()));

      // Delete unnessesary properties
      delete defaultConfig.isDirty;
      delete currentConfig.isDirty;

      delete defaultConfig.isOutputRenderMode;
      delete currentConfig.isOutputRenderMode;

      delete defaultConfig.layoutName;
      delete currentConfig.layoutName;

      delete defaultConfig.previewImages;
      delete currentConfig.previewImages;

      delete defaultConfig.useDivider;
      delete currentConfig.useDivider;

      delete defaultConfig.useDividerHorizontal;
      delete currentConfig.useDividerHorizontal;

      console.log({ defaultConfig, currentConfig });

      for (const key in currentConfig) {
        if (!currentConfig.hasOwnProperty(key)) return;

        const defaultItem = defaultConfig[key];
        const item = currentConfig[key];

        if (Array.isArray(item)) {
          if (item.length != defaultItem.length) {
            return false;
          }
        } else {
          if (item != defaultItem) {
            return false;
          }
        }
      }

      return true;
    },
    setItemSelection(element) {
      this.unsetItemSelection(true);

      element.isSelected = true;
      this.renderStage();

      this.events.fire({ type: 'canvas.onItemSelected', item: element });
    },
    unsetItemSelection(fire) {
      for (let i = 0; i < stageConfig.textBoxes.length; i++) {
        stageConfig.textBoxes[i].isSelected = false;
      }

      for (let i = 0; i < stageConfig.customImages.length; i++) {
        stageConfig.customImages[i].isSelected = false;
      }

      for (let i = 0; i < stageConfig.shapes.length; i++) {
        stageConfig.shapes[i].isSelected = false;
      }

      this.renderStage();

      if (fire) {
        this.events.fire({ type: 'canvas.onItemUnselected' });
      }
    },
    getStageConfig() {
      return stageConfig;
    },
    createShapeContainer(shapes, conf) {
      // conf schema
      /*
       conf = {
       position: {x,y},
       isSelectionEnabled: bool,
       isSelected: bool,
       padding: number,
       rotation: number,
       name: string
       };
       */
      // Validation
      if (!$.isArray(shapes)) {
        console.log('Argument exception: shapes is not an array.');
        return;
      }

      if (!conf) {
        console.log('Argument exception: conf is null.');
        return;
      }

      if (isNaN(conf.padding)) conf.padding = 0;
      if (isNaN(conf.rotation)) conf.rotation = 0;

      // Initialization
      let stage = this.getStage();
      let container = new createjs.Container();
      container.x = conf.position.x;
      container.y = conf.position.y;
      let containerBounds;
      let lastShapeBounds;

      // Add shapes
      for (let i = 0; i < shapes.length; i++) {
        let item = shapes[i];

        if (!item) continue;

        container.addChild(item);

        lastShapeBounds = item.getBounds().clone();

        if (!conf.rotation || conf.rotation == 0) {
          item.x = item.x + conf.padding;
          item.y = item.y + conf.padding;
        } else {
          let boundsRef = item.getBounds();
          let shapeBounds = { width: boundsRef.width, height: boundsRef.height };

          item.rotation = conf.rotation;

          boundsRef = container.getBounds();
          containerBounds = { width: boundsRef.width, height: boundsRef.height };

          let regX = shapeBounds.width / 2 + conf.padding;
          let regY = shapeBounds.height / 2 + conf.padding;

          item.regX = regX;
          item.regY = regY;
          item.x = item.x + containerBounds.width / 2 + conf.padding;
          item.y = item.y + containerBounds.height / 2 + conf.padding;
        }
      }

      containerBounds = container.getBounds();
      container.setBounds(containerBounds.x, containerBounds.y, containerBounds.width + conf.padding * 2, containerBounds.height + conf.padding * 2);

      container.x = container.x - (containerBounds.width / 2 - lastShapeBounds.width / 2);
      container.y = container.y - (containerBounds.height / 2 - lastShapeBounds.height / 2);

      // Border & selection
      if (conf.isSelectionEnabled && !stageConfig.isOutputRenderMode && conf.isSelected) {
        container.cursor = 'move';
        containerBounds = container.getBounds();

        let graphics = new createjs.Graphics();

        if (!stageConfig.isOutputRenderMode && boundElement.isSelected) {
          graphics.setStrokeStyle(2).setStrokeDash([10, 10], 0);
          graphics.beginStroke('#28b4e2');
          graphics.drawRect(0, 0, containerBounds.width, containerBounds.height);
        }

        let containerBackground = new createjs.Shape(graphics);
        container.addChild(containerBackground);

        graphics = new createjs.Graphics();
        graphics.beginFill('black').drawRect(0, 0, containerBounds.width, containerBounds.height);
        let containerHitArea = new createjs.Shape(graphics);
        container.hitArea = containerHitArea;
      }

      return container;
    },
    setRotationRegistrationPoint(shape, container, padding, angle) {
      if (!shape) return;

      if (angle == 0) {
        shape.x = shape.x + padding;
        shape.y = shape.y + padding;
        return;
      }

      // First, get bounds of shape without rotation
      let boundsRef;

      if (typeof shape.getMetrics != 'function') {
        boundsRef = shape.getBounds();
      } else {
        boundsRef = shape.getMetrics();
      }

      if (!boundsRef) return;

      let shapeBounds = { width: boundsRef.width, height: boundsRef.height };

      // Set rotation
      shape.rotation = angle;

      // Then, get the bounds of the container
      let containerBounds = { width: 0, height: 0 };

      if (typeof container.getBounds != 'function') {
        containerBounds = { width: container.width, height: container.height };
      } else {
        boundsRef = container.getBounds();
        containerBounds = { width: boundsRef.width, height: boundsRef.height };
      }

      let regX = shapeBounds.width / 2 + padding;
      let regY = shapeBounds.height / 2 + padding;

      shape.regX = regX;
      shape.regY = regY;
      shape.x = shape.x + containerBounds.width / 2 + padding;
      shape.y = shape.y + containerBounds.height / 2 + padding;

      /*console.log({
       rotation: shape.rotation,
       regX: shape.regX,
       regY: shape.regY,
       x: shape.x,
       y: shape.y,
       });*/
      //container.x = container.x - (containerBounds.width / 2 - shapeBounds.width / 2);
      //container.y = container.y - (containerBounds.height / 2 - shapeBounds.height / 2);
    },
    getDragContainer(type, shape, index, padding, angle) {
      let stage = this.getStage();
      let bounds = this.getBounds();
      let container = new createjs.Container();
      container.name = 'shape-' + type + '-box-' + index;
      //container.cursor = 'move';
      let containerBounds = null;
      let eventTarget = this.events;
      let reference = this;

      let boundElement = null;

      if (type == 'text') {
        boundElement = stageConfig.textBoxes[index];
      } else if (type == 'image') {
        boundElement = stageConfig.customImages[index];
      } else if (type == 'shape') {
        boundElement = stageConfig.shapes[index];
      }

      // Add children
      if ($.isArray(shape)) {
        for (let i = 0; i < shape.length; i++) {
          let item = shape[i];

          if (!item) continue;

          container.addChild(item);
          this.setRotationRegistrationPoint(item, container, padding, angle);
        }
      } else {
        container.addChild(shape);
        this.setRotationRegistrationPoint(shape, container, padding, angle);
      }

      containerBounds = container.getBounds();

      if (!containerBounds) {
        console.log({
          container
        })
        return container;
      }

      container.setBounds(containerBounds.x, containerBounds.y, containerBounds.width + padding * 2, containerBounds.height + padding * 2);

      // Visual Border
      containerBounds = container.getBounds();
      let graphics = new createjs.Graphics();

      if (!stageConfig.isOutputRenderMode && boundElement.isSelected) {
        graphics.setStrokeStyle(2).setStrokeDash([10, 10], 0);
        graphics.beginStroke('#28b4e2');
        graphics.beginFill('rgba(255, 255, 255, 0.01)');
        graphics.drawRect(0, 0, containerBounds.width, containerBounds.height);
      }

      let containerBackground = new createjs.Shape(graphics);
      containerBackground.cursor = 'move';
      container.addChild(containerBackground);

      //graphics = new createjs.Graphics();
      //graphics.beginFill('black').drawRect(0, 0, containerBounds.width, containerBounds.height);
      //let containerHitArea = new createjs.Shape(graphics);
      //container.hitArea = containerHitArea;

      // Add active edges on supporting elements
      const state = { isResizing: false, eventTarget, reference, type, index };

      if (enableActiveEdges && !stageConfig.isOutputRenderMode && boundElement.isSelected && boundElement.supportsActiveEdges) {
        this.addActiveEdge(container, 0, 0, 'nwse-resize', state); // Top left
        this.addActiveEdge(container, containerBounds.width, 0, 'nesw-resize', state); // Top right
        this.addActiveEdge(container, 0, containerBounds.height, 'nesw-resize', state); // Bottom left
        this.addActiveEdge(container, containerBounds.width, containerBounds.height, 'nwse-resize', state); // Bottom right
      }

      // Events
      let dragRelativeX = 0,
        dragRelativeY = 0;

      container.on('pressmove', function (evt) {
        if (state.isResizing) return;

        let name = evt.currentTarget.name;
        let index = name.substring(name.lastIndexOf('-') + 1);
        let element = null;

        if (type == 'text') {
          element = stageConfig.textBoxes[index];
        } else if (type == 'image') {
          element = stageConfig.customImages[index];
        } else if (type == 'shape') {
          element = stageConfig.shapes[index];
        }

        if (dragRelativeX == 0) dragRelativeX = evt.stageX - Math.round(evt.currentTarget.x);

        if (dragRelativeY == 0) dragRelativeY = evt.stageY - Math.round(evt.currentTarget.y);

        let elementBounds = containerBounds;
        let newX = evt.stageX - dragRelativeX,
          newY = evt.stageY - dragRelativeY;
        let expectedMaxValueTop = maxNegativeDragOffset;
        let expectedMaxValueRight = bounds.width - maxNegativeDragOffset - elementBounds.width;
        let expectedMaxValueBottom = bounds.height - maxNegativeDragOffset - elementBounds.height;
        let expectedMaxValueLeft = maxNegativeDragOffset;

        if (newX < expectedMaxValueLeft) newX = expectedMaxValueLeft;
        else if (newX > expectedMaxValueRight) newX = expectedMaxValueRight;
        if (newY < expectedMaxValueTop) newY = expectedMaxValueTop;
        else if (newY > expectedMaxValueBottom) newY = expectedMaxValueBottom;

        element.position.x = newX;
        element.position.y = newY;
        evt.currentTarget.x = newX;
        evt.currentTarget.y = newY;
        stage.update();
      });
      container.on('pressup', function (evt) {
        if (state.isResizing) return;

        dragRelativeX = 0;
        dragRelativeY = 0;

        reference.unsetItemSelection(false);

        let name = evt.currentTarget.name;
        let index = name.substring(name.lastIndexOf('-') + 1);
        let element = null;

        if (type == 'text') {
          element = stageConfig.textBoxes[index];
          element.isSelected = true;
        } else if (type == 'image') {
          element = stageConfig.customImages[index];
          element.isSelected = true;
        } else if (type == 'shape') {
          element = stageConfig.shapes[index];
          element.isSelected = true;
        }

        reference.renderStage();

        eventTarget.fire({ type: 'canvas.onItemSelected', item: element });
      });

      return container;
    },
    addActiveEdge(parent, x, y, cursor, state) {
      const stage = this.getStage();
      const edgeRadius = 12;
      const strokeWidth = 4;
      let graphics = new createjs.Graphics();

      graphics.setStrokeStyle(strokeWidth);
      graphics.beginStroke('#28b4e2');
      graphics.beginFill('#c1effe');
      graphics.drawCircle(x, y, edgeRadius);

      const edge = new createjs.Shape(graphics);
      edge.cursor = cursor;
      parent.addChild(edge);

      let dragStartPosX = 0,
        dragStartPosY = 0,
        initialSize = 0;
      let element = null;
      let scaleFactor = 0;
      let setElementSize = size => {
        if (state.type == 'text') {
          if (size < 20) size = 20;
          else if (size > 300) size = 300;

          element.fontSize = size;
        } else if (state.type == 'image') {
          if (size < 0.1) size = 0.1;
          else if (size > 5) size = 5;

          element.size = size;
        }
      };

      if (state.type == 'text') {
        element = stageConfig.textBoxes[state.index];
        initialSize = element.fontSize;
        scaleFactor = 10;
      } else if (state.type == 'image') {
        element = stageConfig.customImages[state.index];
        initialSize = element.size;
        scaleFactor = 0.85;
      } else if (state.type == 'shape') {
        element = stageConfig.shapes[state.index];
        initialSize = element.widht;
        scaleFactor = 0.85;
      }

      edge.on('pressmove', function (evt) {
        state.isResizing = true;

        if (dragStartPosX == 0) dragStartPosX = evt.stageX;

        if (dragStartPosY == 0) dragStartPosY = evt.stageY;

        const point1 = { x: dragStartPosX, y: dragStartPosY };
        const point2 = { x: evt.stageX, y: evt.stageY };
        const dx = point1.x - point2.x;
        const dy = point1.y - point2.y;
        const isSmaller = dx < 0 || dy < 0;
        const distance = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
        let distanceRelative = (initialSize * distance * scaleFactor) / 100;

        if (!isSmaller) distanceRelative = distanceRelative * -1;

        let newSize = initialSize + distanceRelative;

        console.log(distance, isSmaller, initialSize, newSize, distanceRelative);

        setElementSize(newSize);
        state.reference.renderStage();
      });
      edge.on('pressup', function (evt) {
        state.isResizing = true;

        state.reference.unsetItemSelection(false);
        let element = null;

        if (state.type == 'text') {
          element = stageConfig.textBoxes[state.index];
          element.isSelected = true;
        } else if (state.type == 'image') {
          element = stageConfig.customImages[state.index];
          element.isSelected = true;
        } else if (state.type == 'shape') {
          element = stageConfig.shapes[state.index];
          element.isSelected = true;
        }

        state.reference.renderStage();
        state.eventTarget.fire({ type: 'canvas.onItemSelected', item: element });
      });
    },
    // Drawing functions
    setBackgroundColor(color) {
      stageConfig.backgroundColor = color;
      this.renderStage();
    },
    setBackgroundImage(image) {
      if (image == null) {
        stageConfig.backgroundImage = null;
        this.renderStage();
        return;
      }

      let backgroundImage = new Image();
      backgroundImage.onload = function () {
        window.CanvasService.renderStage();
      };
      stageConfig.backgroundImage = backgroundImage;
      backgroundImage.src = image;
    },
    setBackgroundImageZoom(zoom) {
      stageConfig.backgroundImageScale = zoom;
      this.renderStage();
    },
    setBackgroundImageRotation(angle) {
      stageConfig.backgroundImageRotation += angle;

      if (stageConfig.backgroundImageRotation >= 360 || stageConfig.backgroundImageRotation <= -360) {
        stageConfig.backgroundImageRotation = 0;
      }

      this.renderStage();
    },
    setPreviewImages(images, layoutName) {
      stageConfig.previewImages = images;
      stageConfig.layoutName = layoutName;
      this.renderStage();
    },
    setPreviewImagesBorderType(type) {
      stageConfig.borderType = type;

      if (type == 'none') stageConfig.borderWidth = 0;
      else if (stageConfig.borderWidth == 0) stageConfig.borderWidth = defaultBorderWidth;

      this.renderStage();
    },
    setPreviewImagesBorderRadius(radius) {
      stageConfig.borderRadius = radius;
      this.renderStage();
    },
    setPreviewImagesBorderColor(color) {
      stageConfig.borderColor = color;

      if (stageConfig.borderWidth == 0) stageConfig.borderWidth = defaultBorderWidth;

      this.renderStage();
    },
    setPreviewImagesBorderWith(width) {
      stageConfig.borderWidth = width;
      this.renderStage();
    },
    setUseDivider(useDivider) {
      stageConfig.useDivider = useDivider;
    },
    setUseDividerHorizontal(useDivider) {
      stageConfig.useDividerHorizontal = useDivider;
    },
    addTextBox() {
      const newItem = {
        type: 'text',
        isSelected: false,
        text: 'Mein Text',
        font: 'Arial',
        fontSize: 70,
        fontColor: '#28b4e2',
        borderWidth: 0,
        borderColor: '#ffffff',
        shadowWidth: 0,
        rotation: 0,
        position: { x: 0, y: 0 },
        supportsActiveEdges: true,
        userZIndex: 0
      };
      stageConfig.textBoxes.push(newItem);
      this.setItemSelection(newItem);
      return newItem;
    },
    removeTextBox(item) {
      for (let i = 0; i < stageConfig.textBoxes.length; i++) {
        if (stageConfig.textBoxes[i].name == item.name) {
          stageConfig.textBoxes.splice(stageConfig.textBoxes[i], 1);
          this.renderStage();
          this.unsetItemSelection(true);
          return;
        }
      }
    },
    addCustomImage(image) {
      const newItem = {
        type: 'image',
        isSelected: false,
        image,
        size: 1,
        rotation: 0,
        position: { x: 0, y: 0 },
        supportsActiveEdges: true,
        userZIndex: 0
      };
      stageConfig.customImages.push(newItem);
      this.setItemSelection(newItem);
      return newItem;
    },
    removeCustomImage(item) {
      for (let i = 0; i < stageConfig.customImages.length; i++) {
        if (stageConfig.customImages[i].name == item.name) {
          stageConfig.customImages.splice(stageConfig.customImages[i], 1);
          this.renderStage();
          this.unsetItemSelection(true);
          return;
        }
      }
    },
    addShape() {
      const newItem = {
        type: 'shape',
        isSelected: false,
        shape: 'rectangle',
        // Reactangle / Suqare / Triangle / Circle
        width: 400, // Also radius for circle
        height: 100,
        backgroundColor: '#BDBDBD',
        backgroundOpacity: 0.5,
        borderWidth: 4,
        borderColor: '#000000',
        shadowWidth: 0,
        rotation: 0,
        position: { x: 0, y: 0 },
        supportsActiveEdges: true,
        userZIndex: 0
      };
      stageConfig.shapes.push(newItem);
      this.setItemSelection(newItem);
      return newItem;
    },
    removeShape(item) {
      for (let i = 0; i < stageConfig.shapes.length; i++) {
        if (stageConfig.shapes[i].name == item.name) {
          stageConfig.shapes.splice(stageConfig.shapes[i], 1);
          this.renderStage();
          this.unsetItemSelection(true);
          return;
        }
      }
    },
    // Scaling functions
    getTransformationMatrix(sourceW, sourceH, targetW, targetH, x, y, mode, angle = 0) {
      // Validation
      let modes = ['noscaling', 'contain', 'cover'];

      if (!$.inArray(mode, modes)) {
        $scope.log('WARNING: Mode "' + mode + '" is not supported!');
      }

      // Calculate the scaling factor (up or downwards)
      let transformMatrix = new createjs.Matrix2D();
      let scaleW = 1,
        scaleH = 1,
        scalingFactor = 1;

      if (mode != 'noscaling') {
        scaleW = targetW / sourceW;
        scaleH = targetH / sourceH;

        //console.log({ scaleW: scaleW, scaleH: scaleH, mode: mode });

        if (mode == 'cover') {
          scalingFactor = Math.max(scaleW, scaleH);
        } else {
          scalingFactor = Math.min(scaleW, scaleH);
        }
      }

      // Set scaling and offset
      let translateXOffset = (targetW - sourceW * scalingFactor) / 2;
      let translateYOffset = (targetH - sourceH * scalingFactor) / 2;

      //console.log({ x: x, y: y, xOffset: translateXOffset, yOffset: translateYOffset });

      transformMatrix.translate(x + translateXOffset, y + translateYOffset);
      transformMatrix.scale(scalingFactor, scalingFactor);

      if (angle != 0) {
        if (targetW > targetH) {
          transformMatrix.translate(targetW / 2, targetH / 2);
          transformMatrix.rotate(angle);
          transformMatrix.translate((targetW / 2) * -1, (targetH / 2) * -1);

          if (angle == -90 || angle == 90 || angle == -270 || angle == 270) {
            const scale = targetW / targetH;
            transformMatrix.translate((targetW - targetH) / -2, (targetW - targetH) / -2);
            transformMatrix.scale(scale, scale);
          }
        } else if (targetW < targetH) {
          transformMatrix.translate(targetH / 2, targetW / 2);
          transformMatrix.rotate(angle);
          transformMatrix.translate((targetH / 2) * -1, (targetW / 2) * -1);

          if (angle == -90 || angle == 90 || angle == -270 || angle == 270) {
          } else if (angle == -90 || angle == 90 || angle == -270 || angle == 270) {
            //const scale = targetH / targetW;
            //transformMatrix.translate((targetW - targetH) / -2, (targetW - targetH) / -2);
            //transformMatrix.scale(scale, scale);
          }
        }
      }

      return {
        matrix: transformMatrix,
        width: sourceW * scalingFactor,
        height: sourceH * scalingFactor,
        x: x + translateXOffset,
        y: y + translateYOffset
      };
    },
    // User Z-Index
    applyZIndex(item, action) {
      item.userZIndex = item.userZIndex || 0;
      let firstIndex = 0;
      let lastIndex = 0;

      let stack = [...stageConfig.customImages, ...stageConfig.textBoxes, ...stageConfig.shapes];
      stack = sortBy(stack, ['userZIndex']);
      firstIndex = stack[0];
      lastIndex = stack[stack.length - 1];

      switch (action) {
        case 'bringForward':
          ++item.userZIndex;
          break;
        case 'sendBackward':
          --item.userZIndex;
          break;
        case 'bringToFront':
          item.userZIndex = lastIndex + 1;
          break;
        case 'sendToBack':
          item.userZIndex = firstIndex - 1;
          break;
      }

      this.renderStage();
    },
    // Rendering
    renderGuides(stage, bounds, paddingFromEdge, sides) {
      let guideColor = '#00ffff';
      let createGuide = function (x, y, width, height) {
        let guide = new createjs.Shape();
        let graphics = guide.graphics;
        graphics.beginFill(guideColor).drawRect(x, y, width, height);
        guide.name = 'guide-' + width + '-' + height;
        stage.addChild(guide);
      };

      if (sides === 'top' || sides === 'all') {
        createGuide(0, paddingFromEdge, bounds.width, 2);
      }
      if (sides === 'right' || sides === 'all') {
        createGuide(bounds.width - paddingFromEdge, 0, 2, bounds.height);
      }
      if (sides === 'bottom' || sides === 'all') {
        createGuide(0, bounds.height - paddingFromEdge, bounds.width, 2);
      }
      if (sides === 'left' || sides === 'all') {
        createGuide(paddingFromEdge, 0, 2, bounds.height);
      }
    },
    renderDivider(stage, bounds, horizontal = false) {
      let dividerColor = '#000000';
      let dividerWidth = 6;
      let divider = new createjs.Shape();
      let graphics = divider.graphics;
      let icon = new Image();
      let bitmap = new createjs.Bitmap(icon);
      bitmap.scaleX = 0.08;
      bitmap.scaleY = 0.08;
      stage.addChild(bitmap);

      if(horizontal) {
        graphics
          .beginStroke(dividerColor)
          .setStrokeStyle(dividerWidth)
          .setStrokeDash([20, 20])
          .drawRect(-5, bounds.height / 2 - dividerWidth / 2 + 1, bounds.width + 10, 999999);
        divider.name = 'divider';
        stage.addChild(divider);

        icon.onload = function () {
          let bitmapBounds = bitmap.getBounds();
          bitmap.x = 100;
          bitmap.y = bounds.height / 2 - bitmapBounds.height / 2 + 23;
          bitmap.rotation = 90;
          stage.update();
        };
      } else {
        graphics
          .beginStroke(dividerColor)
          .setStrokeStyle(dividerWidth)
          .setStrokeDash([20, 20])
          .drawRect(bounds.width / 2 - dividerWidth / 2 + 1, -5, 999999, bounds.height + 10);
        divider.name = 'divider';
        stage.addChild(divider);

        icon.onload = function () {
          let bitmapBounds = bitmap.getBounds();
          bitmap.x = bounds.width / 2 - bitmapBounds.width / 2 + 25;
          bitmap.y = bounds.height - bitmapBounds.height - 30;
          stage.update();
        };
      }

      icon.src = scissorsIcon;
    },
    renderStage() {
      this.clearStage();
      let stage = this.getStage();
      let bounds = this.getBounds();
      let zindex = 0;
      let container;

      // STEP 1: Background
      //
      // Render background color
      if (stageConfig.backgroundColor) {
        let backgroundColorShape = new createjs.Shape();
        let graphics = backgroundColorShape.graphics;
        graphics.beginFill(stageConfig.backgroundColor).drawRect(0, 0, bounds.width, bounds.height);
        backgroundColorShape.name = 'shape-background-color';
        this.addElement(backgroundColorShape, zindex++);
      }

      // Render background image
      if (stageConfig.backgroundImage) {
        let backgroundImageShape = new createjs.Shape();

        if (stageConfig.backgroundImageScale == 'none') {
          backgroundImageShape.graphics.beginBitmapFill(stageConfig.backgroundImage, 'repeat').drawRect(0, 0, bounds.width, bounds.height);
        } else {
          let result = this.getTransformationMatrix(
            stageConfig.backgroundImage.width,
            stageConfig.backgroundImage.height,
            bounds.width,
            bounds.height,
            0,
            0,
            stageConfig.backgroundImageScale,
            stageConfig.backgroundImageRotation
          );
          backgroundImageShape.graphics.beginBitmapFill(stageConfig.backgroundImage, 'no-repeat', result.matrix).drawRect(result.x, result.y, result.width, result.height);
        }

        //this.setRotationRegistrationPoint(backgroundImageShape, stage, 0, 10);
        backgroundImageShape.name = 'shape-background-image';
        this.addElement(backgroundImageShape, zindex++);
      }

      // STEP 2: Preview images
      //
      // Render preview images
      if (stageConfig.previewImages) {
        let previewImageIndex = 0;
        let previewPhotoId = -1;

        for (let i = 0; i < stageConfig.previewImages.length; i++) {
          let conf = stageConfig.previewImages[i];
          container = new createjs.Container();
          let graphics = new createjs.Graphics();

          if (previewPhotoId === conf.photoId) {
            if (previewImageIndex > 0) {
              previewImageIndex -= 1;
            } else {
              previewImageIndex = previewImageCounter - 1;
            }
          }

          previewPhotoId = conf.photoId;

          if (stageConfig.isOutputRenderMode) {
            graphics.beginFill('black');
          } else {
            // Fill with bitmap & transform
            let previewImageFill = previewImages[previewImageIndex];
            let result = this.getTransformationMatrix(previewImageFill.width, previewImageFill.height, conf.w, conf.h, 0, 0, 'cover');
            graphics.beginBitmapFill(previewImageFill.image, 'no-repeat', result.matrix);
          }

          if (stageConfig.borderType == 'none' || stageConfig.borderType == 'rect') graphics.drawRect(0, 0, conf.w, conf.h);
          else graphics.drawRoundRect(0, 0, conf.w, conf.h, stageConfig.borderRadius);

          let previewImageShape = new createjs.Shape(graphics);
          previewImageShape.setBounds(0, 0, conf.w, conf.h);

          if (stageConfig.isOutputRenderMode) {
            previewImageShape.compositeOperation = 'destination-out';
          }

          container.addChild(previewImageShape);

          // Add photo ids
          if (!stageConfig.isOutputRenderMode) {
            let shapeRadius = 90;
            let photoIdShape = new createjs.Shape();
            let g = photoIdShape.graphics;
            g.setStrokeStyle(5);
            g.beginStroke('rgba(255, 255, 255, 0.8)');
            g.beginFill('rgba(255, 255, 255, 0.7)').drawRoundRect(
              (conf.w - shapeRadius * 2) / 2, // axis x
              (conf.h - shapeRadius * 2) / 2, // axis y
              shapeRadius * 2, // width
              shapeRadius * 2, // height
              shapeRadius // Corner radius
            );
            container.addChild(photoIdShape);

            let text = new createjs.Text(conf.photoId || 1, '120px Roboto', 'black');
            text.textBaseline = 'middle';
            let textBounds = {
              width: text.getMeasuredWidth(),
              height: text.getMeasuredHeight()
            };
            text.x = (conf.w - textBounds.width) / 2;
            text.y = (conf.h - textBounds.height + 124) / 2;
            container.addChild(text);
          }

          // Add border shape
          if (stageConfig.borderWidth > 0) {
            graphics = new createjs.Graphics();
            graphics.setStrokeStyle(stageConfig.borderWidth);
            graphics.beginStroke(stageConfig.borderColor);

            if (stageConfig.borderType == 'none' || stageConfig.borderType == 'rect') graphics.drawRect(0, 0, conf.w, conf.h);
            else graphics.drawRoundRect(0, 0, conf.w, conf.h, stageConfig.borderRadius);

            let borderShape = new createjs.Shape(graphics);
            borderShape.setBounds(0, 0, conf.w, conf.h);
            container.addChild(borderShape);
          }

          container = this.createShapeContainer([container], {
            name: 'shape-preview-image-' + conf.id,
            position: { x: conf.y, y: conf.x },
            rotation: conf.rotation,
            isSelectionEnabled: false
          });

          this.addElement(container, zindex);

          previewImageIndex++;

          if (previewImageIndex >= previewImageCounter) {
            previewImageIndex = 0;
          }
        }

        zindex++;
      }

      // STEP 3: Generate a layer stack of all user drawables
      let stack = [];

      // Render custom images
      if (stageConfig.customImages) {
        for (let i = 0; i < stageConfig.customImages.length; i++) {
          let imageConf = stageConfig.customImages[i];

          if (!imageConf) continue;

          // Image frame;
          let image = new createjs.Bitmap(imageConf.image);

          if (imageConf.size != 1) {
            image.scaleX = imageConf.size;
            image.scaleY = imageConf.size;
          }

          container = this.getDragContainer('image', image, i, 1, imageConf.rotation);
          let containerBounds = container.getBounds();

          if (imageConf.position.x == 0 && imageConf.position.y == 0) {
            container.x = (bounds.width - containerBounds.width) / 2;
            container.y = (bounds.height - containerBounds.height) / 2;
          } else {
            container.x = imageConf.position.x;
            container.y = imageConf.position.y;
          }

          container.userZIndex = imageConf.userZIndex;
          stack.push(container);
          //this.addElement(container, zindex);
        }

        zindex++;
      }

      // Render custom shapes
      if (stageConfig.shapes) {
        for (let i = 0; i < stageConfig.shapes.length; i++) {
          let shape = stageConfig.shapes[i];
          container = new createjs.Container();
          let graphics = new createjs.Graphics();
          let shapeBounds = { x: 0, y: 0, width: 0, height: 0 };
          let shapeBackground = hexToRgb(shape.backgroundColor);
          shapeBackground = `rgba(${shapeBackground.r}, ${shapeBackground.g}, ${shapeBackground.b}, ${shape.backgroundOpacity})`;

          if (shape.borderWidth > 0) {
            graphics.setStrokeStyle(shape.borderWidth).beginStroke(shape.borderColor);
          }

          graphics.beginFill(shapeBackground);

          switch (shape.shape) {
            case 'rectangle':
              graphics.drawRect(0, 0, shape.width, shape.height);
              shapeBounds = { x: 0, y: 0, width: shape.width, height: shape.height };
              break;
            case 'square':
              graphics.drawRect(0, 0, shape.width, shape.width);
              shapeBounds = { x: 0, y: 0, width: shape.width, height: shape.width };
              break;
            case 'circle':
              graphics.drawCircle(shape.width / 2, shape.width / 2, shape.width / 2);
              shapeBounds = { x: 0, y: 0, width: shape.width, height: shape.width };
              break;
            case 'triangle':
              graphics.drawPolyStar(shape.width / 2, shape.width / 2, shape.width / 2, 3, 0, -90);
              shapeBounds = { x: 0, y: 0, width: shape.width, height: shape.width };
              break;
            default:
              throw new Error(`Unsupported shape '${shape.shape}'.`);
          }

          const shapeElement = new createjs.Shape(graphics);

          if (shape.shadowWidth > 0) {
            shapeElement.shadow = new createjs.Shadow('rgba(0, 0, 0, 0.4)', 0, 2, shape.shadowWidth);
          }

          shapeElement.setBounds(shapeBounds.x, shapeBounds.y, shapeBounds.width, shapeBounds.height);
          container.addChild(shapeElement);
          container = this.getDragContainer('shape', container, i, 6, shape.rotation);
          let containerBounds = container.getBounds();

          if (shape.position.x == 0 || shape.position.y == 0) {
            container.x = (bounds.width - containerBounds.width) / 2;
            container.y = (bounds.height - containerBounds.height) / 2;
          } else {
            container.x = shape.position.x;
            container.y = shape.position.y;
          }

          container.userZIndex = shape.userZIndex;
          stack.push(container);
        }

        zindex++;
      }

      // Render text boxes
      if (stageConfig.textBoxes) {
        for (let i = 0; i < stageConfig.textBoxes.length; i++) {
          let textBox = stageConfig.textBoxes[i];
          container = new createjs.Container();

          let textContent = textBox.text.length > 0 ? textBox.text : 'Text';

          // Text frame
          let text = new createjs.Text(textContent, textBox.fontSize + 'px ' + textBox.font, textBox.fontColor);
          text.textBaseline = 'alphabetic';
          let textBounds = { width: text.getMeasuredWidth(), height: text.getMeasuredHeight() };
          text.y = text.getMeasuredLineHeight();

          let textBorder = null;

          if (textBox.borderWidth > 0) {
            // Workaround: lineJoin = round prevents stroke distortion on text
            let cxt = stage.canvas.getContext('2d');
            cxt.save();
            cxt.lineJoin = 'round';
            cxt.miterLimit = 2;

            textBorder = new createjs.Text(textContent, textBox.fontSize + 'px ' + textBox.font, textBox.borderColor);
            textBorder.textBaseline = 'alphabetic';
            textBorder.x = textBorder.x;
            textBorder.y = textBorder.getMeasuredLineHeight();
            textBorder.outline = textBox.borderWidth;
          }

          let textShadow = null;

          if (textBox.shadowWidth > 0) {
            let shadow = new createjs.Shadow('rgba(0,0,0,0.9)', 0, 1, textBox.shadowWidth);

            textShadow = new createjs.Text(textContent, textBox.fontSize + 'px ' + textBox.font, textBox.fontColor);
            textShadow.textBaseline = 'alphabetic';
            textShadow.x = textShadow.x;
            textShadow.y = textShadow.getMeasuredLineHeight();
            textShadow.shadow = shadow;
          }

          if (textShadow) container.addChild(textShadow);
          if (textBorder) container.addChild(textBorder);
          container.addChild(text);
          container = this.getDragContainer('text', container, i, 6, textBox.rotation);
          let containerBounds = container.getBounds();

          if (textBox.position.x == 0 || textBox.position.y == 0) {
            container.x = (bounds.width - containerBounds.width) / 2;
            container.y = (bounds.height - containerBounds.height) / 2;
          } else {
            container.x = textBox.position.x;
            container.y = textBox.position.y;
          }

          container.userZIndex = textBox.userZIndex;
          stack.push(container);
          //this.addElement(container, zindex);
        }

        zindex++;
      }

      // Sort by z-index
      stack = sortBy(stack, ['userZIndex']);
      let stackZIndex = zindex;

      // Render to canvas
      for (const item of stack) {
        this.addElement(item, stackZIndex++);
      }

      zindex += stackZIndex + 1;

      // STEP 4: Guides & divider
      if (!stageConfig.isOutputRenderMode) {
        this.renderGuides(stage, bounds, defaultMarginFromEdges, 'all');

        if (stageConfig.useDivider) {
          this.renderDivider(stage, bounds);
        }

        if (stageConfig.useDividerHorizontal) {
          this.renderDivider(stage, bounds, true);
        }
      }

      // STEP 5: Update stage
      stage.update();
      this.setDirty();
    },
    // Exporting & Importing
    serializeCanvas(useBlob, handler) {
      let stage = this.getStage();
      let bounds = this.getBounds();

      stageConfig.isOutputRenderMode = true;
      this.renderStage();
      let imgData;

      if (useBlob) {
        imgData = stage.canvas.toBlob(data => {
          handler(data);

          stageConfig.isOutputRenderMode = false;
          this.renderStage();
        });
      } else {
        imgData = stage.canvas.toDataURL();

        stageConfig.isOutputRenderMode = false;
        this.renderStage();
      }

      return imgData;
    },
    saveCanvasToJson() {
      let stage = this.getStage();
      let stageConfig = this.getStageConfig();
      let conf = { saveDate: new Date() };

      conf.canvasSize = this.getBounds();
      conf.layoutName = stageConfig.layoutName;

      if (stageConfig.previewImages && stageConfig.previewImages.length > 0) {
        conf.previewImages = stageConfig.previewImages;
      }

      if (stageConfig.borderType) {
        conf.borderType = stageConfig.borderType;
      }

      if (stageConfig.borderColor) {
        conf.borderColor = stageConfig.borderColor;
      }

      if (stageConfig.borderWidth) {
        conf.borderWidth = stageConfig.borderWidth;
      }

      if (stageConfig.borderRadius) {
        conf.borderRadius = stageConfig.borderRadius;
      }

      if (stageConfig.backgroundColor) {
        conf.backgroundColor = stageConfig.backgroundColor;
      }

      if (stageConfig.backgroundImage) {
        let imgData = this.convertImageToDataUrl(stageConfig.backgroundImage);
        conf.backgroundImage = imgData;
      }

      if (stageConfig.backgroundImageScale) {
        conf.backgroundImageScale = stageConfig.backgroundImageScale;
      }

      if (stageConfig.backgroundImageRotation) {
        conf.backgroundImageRotation = stageConfig.backgroundImageRotation;
      }

      if (stageConfig.textBoxes && stageConfig.textBoxes.length > 0) {
        conf.textBoxes = stageConfig.textBoxes;
      }

      if (stageConfig.customImages && stageConfig.customImages.length > 0) {
        conf.customImages = [];

        for (let i = 0; i < stageConfig.customImages.length; i++) {
          conf.customImages.push(stageConfig.customImages[i]);
          conf.customImages[i].image = this.convertImageToDataUrl(conf.customImages[i].image);
        }
      }

      if (stageConfig.shapes && stageConfig.shapes.length > 0) {
        conf.shapes = stageConfig.shapes;
      }

      //stageConfig = {
      //    isDirty: false,
      //    isOutputRenderMode: false,
      //    layoutName: 'n/a',
      //    previewImages: [],
      //    borderType: 'none',
      //    borderColor: '#FFFFFF',
      //    borderWidth: 0,
      //    borderRadius: 10,
      //    backgroundColor: '#FFFFFF',
      //    backgroundImage: null,
      //    backgroundImageScale: 'cover',
      //    textBoxes: [],
      //    customImages: []
      //};

      let configSerialized = JSON.stringify(conf);
      return configSerialized;
    },
    loadCanvasFromJson(json, finishHandler) {
      let conf = JSON.parse(json);
      this.setStageDefaults();

      if (conf.canvasSize) {
        this.setBounds(conf.canvasSize.width, conf.canvasSize.height);
      }

      if (conf.previewImages && conf.previewImages.length > 0) {
        stageConfig.previewImages = conf.previewImages;
      }

      if (conf.borderType) {
        stageConfig.borderType = conf.borderType;
      }

      if (conf.borderColor) {
        stageConfig.borderColor = conf.borderColor;
      }

      if (conf.borderWidth) {
        stageConfig.borderWidth = conf.borderWidth;
      }

      if (conf.borderRadius) {
        stageConfig.borderRadius = conf.borderRadius;
      }

      if (conf.backgroundColor) {
        stageConfig.backgroundColor = conf.backgroundColor;
      }

      if (conf.backgroundImage) {
        let image = this.convertDataUrlToImage(conf.backgroundImage);
        stageConfig.backgroundImage = image;
      }

      if (conf.backgroundImageScale) {
        stageConfig.backgroundImageScale = conf.backgroundImageScale;
      }

      if (conf.backgroundImageRotation) {
        stageConfig.backgroundImageRotation = conf.backgroundImageRotation;
      }

      if (conf.textBoxes && conf.textBoxes.length > 0) {
        stageConfig.textBoxes = conf.textBoxes;
      }

      if (conf.customImages && conf.customImages.length > 0) {
        for (let i = 0; i < conf.customImages.length; i++) {
          stageConfig.customImages.push(conf.customImages[i]);
          stageConfig.customImages[i].image = this.convertDataUrlToImage(stageConfig.customImages[i].image);
        }
      }

      if (conf.shapes && conf.shapes.length > 0) {
        stageConfig.shapes = conf.shapes;
      }

      let ref = this;

      setTimeout(function () {
        ref.renderStage();

        if (finishHandler) finishHandler();
      }, 3000);
    },
    convertImageToDataUrl(image) {
      //if (!image) return null;

      /*if (
        !(image instanceof HTMLImageElement)
        && !(image instanceof ImageBitmap)
      ) return null;*/

      //if (!image.complete) return null;

      let canvas = document.createElement('CANVAS');
      let ctx = canvas.getContext('2d');
      let dataURL;
      canvas.height = image.height;
      canvas.width = image.width;
      ctx.drawImage(image, 0, 0);
      dataURL = canvas.toDataURL();
      canvas = null;
      return dataURL;
    },
    convertDataUrlToImage(data) {
      let image = new Image();
      image.src = data;
      return image;
    }
  };
}



// WEBPACK FOOTER //
// ./client/components/canvas/canvas.service.js